'use client';

import React from 'react';

import { Input } from '../input';
import { useNumberInput, type NumberInputProps } from './model';

const NumberInput = React.forwardRef<HTMLInputElement, NumberInputProps>(
  (
    {
      value = '',
      onValueChange,
      format = 'integer',
      decimalPlaces = 2,
      dir = 'ltr',
      autoComplete = 'off',
      ...props
    },
    ref
  ) => {
    const { displayValue, setInputRefs, handleChange } = useNumberInput({
      value,
      onValueChange,
      format,
      decimalPlaces,
      ref,
    });

    return (
      <Input
        {...props}
        ref={setInputRefs}
        value={displayValue}
        onChange={handleChange}
        dir={dir}
        autoComplete={autoComplete}
        type='text'
        inputMode={format === 'decimal' ? 'decimal' : 'numeric'}
      />
    );
  }
);

NumberInput.displayName = 'NumberInput';

export { NumberInput };
